<div class="container gap-16" fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="text-16-semi-bold color-text-strong margin-0">
            {{ data.title }}
        </h2>
        <dsn-button-rounded
            [type]="'secondary'"
            size="medium"
            [icon]="'fas fa-times'"
            (click)="onClose()"
        ></dsn-button-rounded>
    </div>
    <img
        [src]="data.imageSrc"
        alt="Nanda IA"
        style="max-width: 100%; height: 184px"
    />
    <h3 class="text-16-semi-bold color-text-strong margin-0">
        {{ data.subtitle }}
    </h3>
    <p
        class="text-14-regular color-text-primary margin-0"
        [innerHTML]="data.description"
    ></p>
    <div class="box-highlight">
        <p
            class="text-14-regular color-text-primary margin-0"
            [innerHTML]="data.hint"
        ></p>
    </div>
    <div class="gap-16" fxLayout="row" fxLayoutAlign="end center">
        <dsn-button
            label="Fechar"
            [type]="'secondary'"
            (click)="onClose()"
        ></dsn-button>
        <dsn-button
            [label]="data.cta"
            [type]="'primary'"
            (click)="onRequestProductGrowth()"
        ></dsn-button>
    </div>
</div>
